import { Address, DeliveryDateType, GenericObject, copyFields, fixDates } from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { Customer } from '../../../common/models/customer';
import { Offer } from '../../../common/models/offer';
import { PurchaseItem } from './purchase-item';
import { User } from '../../../common/models/user';

export class AccountPurchase {
    public id?: number;
    public customerAccount!: Customer;
    public contact!: Contact;
    public deliveryAddress!: Address;

    public offers?: Offer[];
    public avisoContact?: Contact;
    public purchaseItems?: PurchaseItem[];

    public costCentre?: string;
    public functionalAsset?: string;
    public orderReference?: string;
    public deliveryDate?: Date;
    public deliveryDateType: DeliveryDateType = DeliveryDateType.Deadline;

    public createdAt?: Date;
    public createdBy?: User;
    public updatedAt?: Date;
    public updatedBy?: User;

    public static fromPlainObject(object: GenericObject): AccountPurchase {
        const accountPurchase = new AccountPurchase();

        copyFields(object, accountPurchase);

        if (object['contact']) {
            accountPurchase.contact = Contact.fromPlainObject(object['contact']);
        }

        if (object['deliveryAddress']) {
            accountPurchase.deliveryAddress = Address.fromPlainObject(object['deliveryAddress']);
        }

        if (object['avisoContact']) {
            accountPurchase.avisoContact = Contact.fromPlainObject(object['avisoContact']);
        }

        if (object['purchaseItems']) {
            accountPurchase.purchaseItems = object['purchaseItems'].map(PurchaseItem.fromPlainObject);
        }

        if (object['customerAccount']) {
            accountPurchase.customerAccount = Customer.fromPlainObject(object['customerAccount']);
        }

        if (object['offers']) {
            accountPurchase.offers = object['offers'].map(Offer.fromPlainObject);
        }

        if (object['createdBy']) {
            accountPurchase.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            accountPurchase.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        fixDates(accountPurchase, ['createdAt', 'updatedAt']);

        return accountPurchase;
    }
}
